module.exports = __webpack_public_path__ + "static/media/ic_expander.d27c00b9.svg";